module.exports = __webpack_public_path__ + "static/media/estuary.9ff39597.jpg";